class RelatedItemsToggle extends window.BAO.CustomElement() {
  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    if (this.els?.trigger?.element) {
      this.listeners.add(this.els.trigger.element, 'click', this.handleTrigger)
    }
  }

  handleTrigger () {
    const currentState = this.getAttribute('aria-expanded') === 'true'
    this.setAttribute('aria-expanded', !currentState)
  }
}

if (!customElements.get('related-items-toggle')) {
  customElements.define('related-items-toggle', RelatedItemsToggle)
}
